var React = require('react');

function WaveLTR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M119.603 106.85C27.6811 82.8743 3.1337 32.6632 0 0V230H375C375 98.0089 247.198 128.693 151.462 113.105C143.158 111.753 128.221 109.098 119.603 106.85Z","fill":"currentColor"}));
}

WaveLTR.defaultProps = {"viewBox":"0 0 375 230","fill":"none"};

module.exports = WaveLTR;

WaveLTR.default = WaveLTR;
